import React from "react";
import { Link } from "react-router-dom";
import { Lightbulb } from "lucide-react";

/* Prose building blocks for blog articles */

export const P = ({ children }) => (
  <p className="text-[17px] leading-[1.8] text-coal/70">{children}</p>
);

export const XL = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-electric font-medium hover:underline underline-offset-4">
    {children}
  </a>
);

export const IL = ({ to, children }) => (
  <Link to={to} className="text-electric font-medium hover:underline underline-offset-4">
    {children}
  </Link>
);

export const BUl = ({ items }) => (
  <ul className="space-y-2.5 my-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-3 text-[17px] leading-relaxed text-coal/70">
        <span className="mt-[11px] w-1.5 h-1.5 rounded-full bg-electric shrink-0" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export const BOl = ({ items }) => (
  <ol className="space-y-3 my-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-3.5 text-[17px] leading-relaxed text-coal/70">
        <span className="font-display font-black text-electric shrink-0 mt-0.5">{String(i + 1).padStart(2, "0")}</span>
        <span>{item}</span>
      </li>
    ))}
  </ol>
);

export const BTip = ({ title = "Praktijktip van Tim", children }) => (
  <div className="rounded-2xl border border-electric/25 bg-electric/5 p-6 my-2">
    <div className="flex items-center gap-2 mb-2.5">
      <Lightbulb className="w-4 h-4 text-electric" />
      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-electric-700">{title}</span>
    </div>
    <div className="text-[15px] leading-relaxed text-coal/75">{children}</div>
  </div>
);

export const BStat = ({ value, label, source }) => (
  <div className="rounded-2xl bg-obsidian text-ivory p-6 my-2 relative overflow-hidden">
    <div className="glow-orb w-[200px] h-[200px] bg-electric/25 -top-10 -right-6" />
    <div className="relative">
      <div className="font-display font-black text-4xl lg:text-5xl text-electric-300 leading-none">{value}</div>
      <div className="mt-2 text-white/75 text-[15px]">{label}</div>
      {source && <div className="mt-1.5 text-xs text-white/40">Bron: {source}</div>}
    </div>
  </div>
);
